export * from "./types.js";
export * from "./copy.js";
export {
  calculatePackagingShock,
  assertNoProductHandoff,
} from "./calculate.js";
export { fy2025_26 } from "./fy2025-26.js";

import type { FinancialYear } from "../types.js";
import type { PackagingShockRuleSet } from "./types.js";
import { fy2025_26 } from "./fy2025-26.js";

/** Registry of packaging-shock rulesets by financial year. Historical years stay
 * registered so re-runs resolve against the gross-up rate / MLS table in force. */
export const PACKAGING_SHOCK_RULESETS: Record<string, PackagingShockRuleSet> = {
  "2025-26": fy2025_26,
};

/** Resolve the packaging-shock ruleset for a financial year, or throw if unknown. */
export function packagingShockRulesFor(
  fy: FinancialYear,
): PackagingShockRuleSet {
  const rules = PACKAGING_SHOCK_RULESETS[fy];
  if (!rules) {
    throw new Error(`no packaging-shock ruleset registered for FY ${fy}`);
  }
  return rules;
}

/** Most recent packaging-shock ruleset — the default for live "this year" calcs. */
export const PACKAGING_SHOCK_CURRENT_FY: FinancialYear = "2025-26";
